export enum EnteteTableauListeDepensesManuellesEnum {
	fichier_integre = 'Fichier intégré',
	type = 'Type',
	date = 'Date'
}